"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

function _default(_ref) {
  var bubbleMaxWidth = _ref.bubbleMaxWidth,
      bubbleMinWidth = _ref.bubbleMinWidth,
      paddingRegular = _ref.paddingRegular;
  return {
    marginLeft: paddingRegular,
    marginRight: paddingRegular,
    '& > .content': {
      '& > .webchat__row': {
        '& > .bubble, & > .timestamp': {
          maxWidth: bubbleMaxWidth
        },
        '&.attachment > .bubble': {
          minWidth: bubbleMinWidth
        }
      },
      '& > *:not(:first-child):not(:last-child)': {
        marginTop: paddingRegular
      }
    },
    '&.from-user > .avatar': {
      marginLeft: paddingRegular
    },
    '&:not(.from-user) > .avatar': {
      marginRight: paddingRegular
    }
  };
}